export default "__VITE_ASSET__648a4a06__"